import { gql } from '@apollo/client';
import type {
    InhubDataFreshness,
    InhubTransportPerspective
} from '../types';

export const GET_INHUB_TRANSPORT_KPI_SUMMARY = gql`
  query GetInhubTransportKpiSummary($filter: InhubDashboardRangeInput!) {
    getInhubTransportKpiSummary(filter: $filter) {
      outbound {
        perspective
        departed { parcelCount bagCount freshness rate bagRate wowPercent bagCountWowPercent }
        arrived { parcelCount bagCount freshness rate bagRate wowPercent bagCountWowPercent }
        notArrived { parcelCount bagCount freshness rate bagRate wowPercent bagCountWowPercent }
      }
      inbound {
        perspective
        departed { parcelCount bagCount freshness rate bagRate wowPercent bagCountWowPercent }
        arrived { parcelCount bagCount freshness rate bagRate wowPercent bagCountWowPercent }
        notArrived { parcelCount bagCount freshness rate bagRate wowPercent bagCountWowPercent }
      }
      dataCalculatedAtMax
    }
  }
`;

export interface InhubTransportKpiCellResp {
    parcelCount: number;
    bagCount: number;
    freshness: InhubDataFreshness;
    rate: number | null;
    bagRate: number | null;
    wowPercent: number;
    bagCountWowPercent: number;
}

export interface InhubTransportSectionKpiResp {
    perspective: InhubTransportPerspective;
    departed: InhubTransportKpiCellResp;
    arrived: InhubTransportKpiCellResp;
    notArrived: InhubTransportKpiCellResp;
}

export interface GetInhubTransportKpiSummaryResponse {
    getInhubTransportKpiSummary: {
        outbound: InhubTransportSectionKpiResp;
        inbound: InhubTransportSectionKpiResp;
        dataCalculatedAtMax: string | null;
    };
}
